import { RegistrySetRequestTypes } from './actionTypes';

export type GetRegistrySetRequestByWrNumberPayload = {
  pagination: { sizePerPage: number; page: number };
  filters?: { from: String; to: String; dynamicFilter: String };
};

export const getRegistrySetRequest = (payload: GetRegistrySetRequestByWrNumberPayload) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_LIST,
    payload,
  };
};

export const getRegistrySetRequestSuccess = (payload: any) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_LIST_SUCCESS,
    payload,
  };
};

export const getRegistrySetRequestError = (error: any) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_LIST_ERROR,
    payload: error,
  };
};

//------------------------------Filter-----------------------

export const getRegistrySetRequestFilters = () => {
  return {
    type: RegistrySetRequestTypes.GET_FILTER_LIST,
  };
};

export const getRegistrySetRequestFiltersSuccess = (payload: any) => {
  return {
    type: RegistrySetRequestTypes.GET_FILTER_LIST_SUCCESS,
    payload,
  };
};

export const getRegistrySetRequestFiltersError = (error: any) => {
  return {
    type: RegistrySetRequestTypes.GET_FILTER_LIST_ERROR,
    payload: error,
  };
};


//------------------------------Count-----------------------

export const getRegistrySetRequestCount = (payload: any) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_COUNT,
    payload,
  };
};

export const getRegistrySetRequestCountSuccess = (payload: any) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_COUNT_SUCCESS,
    payload,
  };
};

export const getRegistrySetRequestCountError = (error: any) => {
  return {
    type: RegistrySetRequestTypes.GET_TRANSACTION_COUNT_ERROR,
    payload: error,
  };
};